import DefaultView from 'nette-base-module/js/views/default'
import merge from 'lodash/merge'

export default merge({
  inject: {
    ...DefaultView.inject,
    adminModulePanelId: {
      name: 'adminModulePanelId',
      default: null,
    },
  },
}, DefaultView)